module.exports = __webpack_public_path__ + "static/media/fidweb-mobiwash_optimized.5c9786ee.png";